import styled from "styled-components";
import IconContainer from "./IconContainer";

const SuccessIconContainer = styled(IconContainer)`
    color: ${props => props.theme.colors.success};
`

export default SuccessIconContainer;